import { SET_FACEBOOK_READY } from "../../../actionTypes";

export const setFacebookReady = () => {
	return {
		type: SET_FACEBOOK_READY,
	};
};
